import { CREATE_MOBILITY_REPORT, REPORT_ERROR } from 'actions/types'

interface ReportState {
  mobility: undefined | boolean
  currentStep: undefined | string
}

const ReportInitialState = {
  mobility: undefined,
  currentStep: undefined,
}

export const mobilityReducer = (state: ReportState = ReportInitialState, action: any) => {
  const { type, payload } = action

  switch (type) {
    case CREATE_MOBILITY_REPORT:
      return {
        ...state,
        currentStep: payload,
      }
    case REPORT_ERROR:
      return {
        ...state,
        currentStep: payload,
      }
    default:
      return state
  }
}
